let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dQgxL")).then(() => parcelRequire('5Bs06'));